import selectorSelectors from '../redux/selector/selectors'
import { DetailedPolicy } from '../../remote-api/models'
import { APIPolicySelectorState } from './reducer'

export const apiPolicySelectorSelectors = <S>(getAll: (state: S) => APIPolicySelectorState) => {
  return {
    ...selectorSelectors<DetailedPolicy, S>(getAll),
    getAll: (state: S) => getAll(state),
    options: (state: S) => {
      const policies = getAll(state).resources
      return policies ? policies.filter(p => !p.ruleOfApplication).map(policy => {
        const policyName = policy.name ? policy.name : policy.assetId ? policy.assetId.replace(/-/g, ' ') : policy.id
        return {label: policyName, value: policy.id}
      }) : []
    }
  }
}
